<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Search bar -->
    <rect x="6" y="8" width="36" height="8" rx="2" stroke="#666666" stroke-width="1.5" fill="none" />
    <circle cx="12" cy="12" r="2.5" stroke="#666666" stroke-width="1.5" fill="none" />
    <line x1="14" y1="14" x2="16" y2="16" stroke="#666666" stroke-width="1.5" stroke-linecap="round" />
    <!-- Result rows -->
    <rect x="6" y="20" width="36" height="4" rx="1" fill="#D6D6D6" />
    <rect x="6" y="27" width="36" height="4" rx="1" fill="#D6D6D6" />
    <rect x="6" y="34" width="36" height="4" rx="1" fill="#D6D6D6" />
  </svg>
</template>
